import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailStatistics {
  likes: number;
  views: number;
  leadCounts: {
    whatsapp: number;
    call: number;
    mail: number;
    mortgageReferral: number;
  };
}

export const prepareDetailPropertyStatistics = (
  data: IPropertyDetailsResponse
): IPropertyDetailStatistics => {
  const getLeadCount = (type: string): number => {
    const lead = data?.leadCounts?.find(
      lead => lead.name.toLowerCase() === type.toLowerCase()
    );
    return lead?.total_count ? parseInt(lead.total_count, 10) : 0;
  };

  return {
    likes: data?.likes_counter || 0,
    views: data?.views_counter || 0,
    leadCounts: {
      whatsapp: getLeadCount("whatsapp"),
      call: getLeadCount("call"),
      mail: getLeadCount("mail"),
      mortgageReferral: getLeadCount("mortgage referral")
    }
  };
};
